<script setup lang="ts">
import MasterExperienceTab from './MasterExperienceTab.vue';
import MasterReviewsTab from './MasterReviewsTab.vue';
import MasterServicesTab from './MasterServicesTab.vue';
import { type FragmentType, graphql } from '@/gql';

const masterFragment = graphql(/* GraphQL */ `
  fragment MasterDetailsTabs_MasterFragment on Master {
    id
    serviceCount
    reviewCount
  }
`);

const props = defineProps<{
  master: FragmentType<typeof masterFragment>;
  locationIndex?: number;
}>();

const master = useFragmentData(masterFragment, () => props.master);
</script>

<template>
  <AppTabs variant="chips">
    <AppTab class="tab">
      <template #title>
        Услуги
        <span class="font-bold">{{ master.serviceCount }}</span>
      </template>
      <MasterServicesTab :master-id="master.id" />
    </AppTab>
    <AppTab class="tab">
      <template #title>
        Отзывы
        <span class="font-bold">{{ master.reviewCount }}</span>
      </template>
      <MasterReviewsTab :master-id="master.id" />
    </AppTab>
    <AppTab title="Информация" class="tab">
      <MasterExperienceTab :master-id="master.id" />
    </AppTab>
  </AppTabs>
</template>

<style lang="scss" scoped>
@import '@glow/shared/assets/core.scss';

.stub {
  width: 100%;
  height: 100px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: var(--app-color-black-secondary);
}

.tab {
  padding: var(--app-spacing-4) 0 !important;

  @include media-breakpoint-up(sm) {
    padding: var(--app-spacing-6) 0 !important;
  }
}
</style>
